import React from 'react';
import { cn } from '@/lib';
import { LuMousePointerClick } from 'react-icons/lu';
import type { TriggerDisplayProps } from './FlowEmailTimeline.types';

export const TriggerDisplay = React.memo<TriggerDisplayProps>(({ triggerText, triggerType, compact = false }) => {
    const getTriggerLabel = (): string => {
        // For non-time triggers (checkout, cart abandonment, etc.)
        if (triggerType !== 'time') {
            return 'Trigger on:';
        }

        // For time-based triggers, check if it's already sent/scheduled
        const isSentOrScheduled = triggerText.includes('Sent') || triggerText.includes('Scheduled');
        return isSentOrScheduled ? 'Trigger:' : 'Trigger on:';
    };

    const triggerLabel = getTriggerLabel();

    return (
        <div className={cn('pointer-events-none relative z-10 rounded-lg', compact ? 'py-2.5' : 'py-2.5 md:p-2.5')}>
            <div className='text-label-sm-regular flex gap-3 rounded-full'>
                <div className='bg-brand-subtle flex size-7 flex-shrink-0 -translate-x-0.5 items-center justify-center rounded-full'>
                    <LuMousePointerClick className='size-4' />
                </div>
                <div className='flex flex-col gap-0.5'>
                    <p className='text-body-xs text-disabled'>{triggerLabel}</p>
                    <p className='max-md:text-body-xs font-semibold italic'>{triggerText}</p>
                </div>
            </div>
        </div>
    );
});

TriggerDisplay.displayName = 'TriggerDisplay';
